import { render } from "./GuideTour.vue?vue&type=template&id=3d685bc8&scoped=true"
import script from "./GuideTour.vue?vue&type=script&lang=js"
export * from "./GuideTour.vue?vue&type=script&lang=js"

import "./GuideTour.vue?vue&type=style&index=0&id=3d685bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d685bc8"]])

export default __exports__